import { Icon } from '@/general/Icons/Icon';
import clsx from 'clsx';
import { FC, ReactNode } from 'react';

import { KEY_ITEMS } from './CarKeyInformation.type';

interface Item {
  key: KEY_ITEMS;
  value: string;
}

interface Props {
  items: Item[];
}

type KeyItemProps = {
  [key in KEY_ITEMS]: {
    icon: ReactNode;
    label: string;
  };
};

const keyItem: KeyItemProps = {
  [KEY_ITEMS.KILOMETERS]: { icon: <Icon name="meter" size={20} />, label: 'Kilometres' },
  [KEY_ITEMS.COMPLIANCE_YEAR]: { icon: <Icon name="calendar-with-tick" size={20} />, label: 'Compliance year' },
  [KEY_ITEMS.BUILD_YEAR]: { icon: <Icon name="calendar" size={20} />, label: 'Build year' },
  [KEY_ITEMS.ENGINE_SIZE]: { icon: <Icon name="engine" size={20} />, label: 'Engine' },
  [KEY_ITEMS.FUEL_TYPE]: { icon: <Icon name="petrol" size={20} />, label: 'Fuel type' },
  [KEY_ITEMS.TRANSMISSION]: { icon: <Icon name="automatic-transmission" size={20} />, label: 'Drivetrain' },
  [KEY_ITEMS.DRIVE_TYPE]: { icon: <Icon name="drive-type" size={20} />, label: 'Drive type' },
  [KEY_ITEMS.SEATS]: { icon: <Icon name="seats" size={20} />, label: 'Seats' },
  [KEY_ITEMS.LAST_SERVICE_DATE]: { icon: <Icon name="spanner" size={20} />, label: 'Last service date' },
  [KEY_ITEMS.VIN_NUMBER]: { icon: <Icon name="vin" size={20} />, label: 'VIN' },
  [KEY_ITEMS.FUEL_CONSUMPTION]: { icon: <Icon name="fuel-consumption" size={20} />, label: 'Fuel consumption' },
  [KEY_ITEMS.ANCAP_SAFETY_RATING]: { icon: <Icon name="ancap" size={20} />, label: 'ANCAP safety rating' },
  [KEY_ITEMS.KEYS]: { icon: <Icon name="number-of-keys" size={20} />, label: 'Number of keys' },
  [KEY_ITEMS.EXTERIOR_COLOR]: { icon: <Icon name="colour" size={20} />, label: 'Exterior colour' },
  [KEY_ITEMS.ENGINE_POWER]: { icon: <Icon name="engine-power" size={20} />, label: 'Engine power' },
};

export const CarKeyInformation: FC<Props> = ({ items }) => (
  <div className="grid grid-cols-2 gap-4 smp:grid-cols-3">
    {items.length !== 0 &&
      items.map(({ value, key }) => (
        <div
          className={clsx('flex gap-4', {
            ['col-span-2']: key === KEY_ITEMS.VIN_NUMBER,
          })}
          key={key}
        >
          {keyItem[key].icon}
          <dl>
            <dt className="c-fs-body2 text-tex-def-tie2">{keyItem[key].label}</dt>
            <dd className="c-fs-body1" data-testid={`CarKeyInformation-component-${key}-info`}>
              {value}
            </dd>
          </dl>
        </div>
      ))}
  </div>
);
